//import Libraries
import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Input, InputGroup, InputGroupText, Button, InputGroupAddon} from 'reactstrap';

//import Components
import Loading from '../../../components/Loading/Loading';

import CartList from './CartList';
import * as cartActions from '../actions/cartActions';
import * as modalActions from '../../../components/Navigation/actions/modalActions';
// import Styles
import './Cart.css'

const calculateTotalQuantity = (cart) => {
    let quantity = 0;
    if(cart !== null) {
        for (let i = 0; i < cart.length; ++i) {
            quantity += Number(cart[i].quantity);
        }
    }
    return quantity;
}

class Cart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            message : ''
        }
    }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // console.log('cart updated');
    }

    handleOnSendButtonClick = () => {
        if(!this.props.user.login) {
            this.props.onToggleModal('notLoggedIn');
        } else if(!this.props.user.verified || !this.props.user.approved) {
            this.props.onToggleModal('notVerified');
        } else {

            this.props.onSendOrder({
                cart : this.props.cart,
                message : this.state.message
            }, {
                successFunc : this.props.onToggleModal('orderSent')
            });
            this.setState({
                message: ''
            })

        }
    }

    render() {
        const { cart, products } = this.props;
        const totalQuantity = calculateTotalQuantity(cart);
        console.log(totalQuantity);

        if (!cart) {
            return (
                <Loading text={"Cart is Loading"}/>
            );
        }

        if (cart.length === 0) {
            return (
                <div className="cart">
                    <div className="title">
                        선택하신 상품
                    </div>
                    <div className="list">
                        <span>장바구니가 비었습니다.</span>
                    </div>
                </div>
            );
        }

        return (
            <div className="cart">
                <div className="title">
                    선택하신 상품  <span>총 {totalQuantity}</span>
                </div>
                <div className="list">
                    <CartList
                        cart={cart}
                        products={products} 
                        universal={this.props.universal}
                    />
                </div>
                <InputGroup className="MessageWrapper">
                    <InputGroupAddon addonType="prepend">요청메세지
                        {/* <label htmlFor="message">주문메세지</label> */}
                    </InputGroupAddon>
                    <Input 
                        bsSize="lg"
                        onChange={this.handleOnChange}
                        value={this.state.message}
                        name="message"
                        placeholder="요청사항을 입력하세요"
                    />
                    <InputGroupAddon addonType="append">
                        <Button color="success" 
                            onClick={this.handleOnSendButtonClick}
                        >
                            요청하기
                        </Button>
                    </InputGroupAddon>
                </InputGroup>
            </div>
        );
    }
}
    
const mapStateToProps = (state)=>{
   return{
        universal : state.universal,
        cart : state.cart,
        products : state.products,
        user : state.user
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSendOrder : (datas, funcs)=> {
            dispatch(cartActions.sendOrder(datas, funcs));
        },
        onToggleModal : (name) => {
            dispatch(modalActions.toggleModal(name));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cart);


// WEBPACK FOOTER //
// ./src/pages/Store/Cart/Cart.js